<template>
    <div id="rechargeB">
        <div class="header">
            <div><span>接入号：</span>{{ recordLoginText }}</div>
            <div><span>号码：</span>{{ recordLoginText }}</div>
            <div><span>运营商：{{itemInfo.supplierTypeName}}</span></div>
        </div> 
        <div class="packagePanel">
            <h1 class="package-title">选择流量包</h1>
            <div class="tabbar">
                <p :class="{'activeTab':tabbar==1}" @click="tabbarClick('1')">基础套餐</p>
                <p :class="{'activeTab':tabbar==2}" @click="tabbarClick('2')">加油套餐</p>
            </div>
            <div class="package" v-for="item in simData" :key="item.id" 
            @click="changeState(item, '1')" v-show="tabbar==1">
                <span class="label-defined" :class="{'label-defined-active':indexActive==item.id}">
                    <label><van-icon name="success" color="#fff"/></label>
                </span>

                <div class="package-name" :class="{'overlay-package':item.type == 11 || item.type == 13 ||item.type == 20}"> 
                    <h1 style="color: #07c160;" v-if="item.type == 11 || item.type == 13 ||item.type == 16||item.type == 20">{{item.packageName}}</h1>
                    <h1 v-else>{{item.packageName}}</h1>

                    <!-- 生效时间 -->
                    <!-- <p v-if="item.type==11" style="color: #07c160;">
                        有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p> -->
                    <p v-if="(item.type==2 || item.type == 10) && isNextMonth=='1'">
                        有效期：{{firstDayOfNextMonth()}} 至 {{lastDayOfNextMonth()}}</p>
                    <p v-if="(item.type==2 || item.type == 10 ) && isNextMonth=='0'">
                        有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
                    <p v-if="(item.type==15 || item.type == 14 ||item.type == 24) && isNextMonth=='0'">
                        有效期：每月27号0点流量清零</p>
                    <p v-if="(item.type == 14 ||item.type == 24 ) && isNextMonth=='1'">
                        有效期：每月27号0点流量清零</p>
                    <!-- 生效时间 end-->
                   <p v-if="item.type==23">月底清零，无限叠加</p>
                     <p v-if="item.type==21 && item.packageName.includes('100')">订购后可升级为9s.9元100G</p>
                    <p v-if="item.type==21 && item.packageName.includes('200')">订购后可升级为19.9元200G</p>
                      <p v-if="item.type==22 && item.packageName.includes('100')">订购后可升级为9.9元100G</p>
                    <p v-if="item.type==22 && item.packageName.includes('200')">订购后可升级为19.9元200G</p>
                    <!-- 备注信息 -->
                    <p v-if="item.type==12 ||item.type==19||item.type==32||item.type==30">30天有效期，月底不清零</p>
                    <!-- <p v-if="item.type==13">基础套餐用完以后，加油包可无限叠加</p> -->
                    <p v-if="item.type==8 && item.packageName.includes('100')">订购后可升级为9.9元100G</p>
                    <p v-if="item.type==8 && item.packageName.includes('200')">订购后可升级为19.9元200G</p>
                    <p v-if="item.type==15">每充值一次，套餐包自动多延续一个月</p>
                    <p v-if="itemInfo.type==3">套餐月底清零，续费充值次月生效，依次类推。如当月流量用完，需继续使用的请充值加餐包。</p>
                    <p style="color:red">{{item.remark}}</p>
                </div>

                <div class="package-price" :class="{'overlay-package':item.type == 11 || item.type == 13}">
                    <p>优惠价</p>
                    <p>{{item.salePriceRmb}}元</p>
                </div>
            </div>   

            <div class="package" v-for="item in simData2" :key="item.id" 
            @click="changeState(item, 2)" v-show="tabbar==2">
                <span class="label-defined" :class="{'label-defined-active':indexActive2==item.id}">
                    <label><van-icon name="success" color="#fff"/></label>
                </span>

                <div class="package-name" :class="{'overlay-package':item.type == 11 || item.type == 13||item.type==16}"> 
                    <h1 style="color: #07c160;" v-if="item.type == 11 || item.type == 13||item.type==16">{{item.packageName}}</h1>
                    <h1 v-else>{{item.packageName}}</h1>

                    <!-- 生效时间 -->
                    <p v-if="item.type==11" style="color: #07c160;">
                        有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>

                    <!-- 备注信息 -->
                    <p v-if="item.type==13 || item.type==4 ||item.type==16 || item.type==18||item.type == 20||item.type == 31||item.type == 33">基础套餐用完以后，加油包可无限叠加</p>

                    <p v-if="item.type==3">月底清零，基础套餐包流量用完后，当月如需继续使用，请充值加餐包。</p>
                     <p v-if="item.type==15">每充值一次，套餐包自动多延续一个月</p>
                    

                </div>

                <div class="package-price" :class="{'overlay-package':item.type == 11 || item.type == 13 ||item.type == 20}">
                    <p>优惠价</p>
                    <p>{{item.salePriceRmb}}元</p>
                </div>
            </div>   

        </div>




        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay"
            :price="price" 
            :typeStyle="typeStyle"/>
        
        <div class="toRecharge">
            <p style="color: green;text-align:center;padding:5px;border:1px solid green;border-radius:25px;font-size:20px;" v-if="endTime && endTime == 0">提示：套餐升级</p>
            <p style="text-align:center;padding:5px;border:1px solid green;border-radius:25px;font-size:20px;" v-if="endTime && endTime > 0">提示：距离套餐升级还有{{ endTime }}天</p>
            <div class="toRecharge-top" v-if="tabbar == 1 && (showMonthChoose || isNaturalMonth)">
                <van-radio-group v-model="isNextMonth" class="radio-group-defined">
                    <div>
                        <van-radio name="0" checked-color="#26a2ff">本月生效</van-radio>
                    </div>
                    <div>
                        <van-radio name="1" checked-color="#26a2ff">次月生效</van-radio>
                    </div>
                </van-radio-group>
            </div>

            <!-- <p class="detail" v-if="tabbar == 1 && isNaturalMonth && !cuccPkg" style="color: red;">请在有效时间内使用
                <span v-show='this.isNextMonth==0'>，<span style="color: red;">月底清零。</span></span>
                <span v-show='this.isNextMonth==1'>，<span style="color: red;">次月月底清零。</span></span>
            </p>
              <p class="detail" v-if="tabbar == 1 && isNaturalMonth && cuccPkg" style="color: red;">请在有效时间内使用
                <span v-show='this.isNextMonth==0'>，<span style="color: red;">本月27号清零。</span></span>
                <span v-show='this.isNextMonth==1'>，<span style="color: red;">次月27号清零。</span></span>
            </p> -->

            <div class="toRecharge-bottom">
                <p>金额：<span>{{money_format(price, 2, '.', ',')}} 元</span></p>
                <div class="toRechargeBtn" @click="toRecharge()">订 购</div>
            </div>
        </div>

    </div>
</template>
<script>
import { wxRequest} from '@/api/user.js'
import { Dialog } from 'vant';
import { Toast } from 'vant';
import Checkstand from "@/components/Checkstand";

export default {
    components: {Checkstand},
    data(){
        return {
            cuccPkg:false,
            indexActive: '',
            simData: [],

            itemInfo: {
                supplierTypeName: localStorage.getItem('supplierTypeName'),
                flowRate: '',
                salePriceRmb: ''
            },
            isAdmin: '',
            globalIsAdmin: '',
            isNextMonth: '0',
            payType: 1,
            isNaturalMonth: false,
            showCheckstand: false,
            showMonthChoose: false,//判断是否显示本月次月

            //收银台
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            dataToPay: {},
            price:0,
            typeStyle: 1, //流量充值入口为1
            tabbar: 1,
            recordLoginText: localStorage.getItem('recordLoginText'),
            endTime: null, //判断年卡是否显示


            simData2: [],
            indexActive2: '',
            itemInfo2: {
                supplierTypeName: '',
                flowRate: '',
                salePriceRmb: ''
            }
        }
    },
    methods: {
        changeState(item, tabbar){
            if(tabbar == 1){
                this.indexActive = item.id;
                this.itemInfo = item; 
                this.price = item.salePriceRmb;
            }else {
                this.indexActive2 = item.id;
                this.itemInfo2 = item; 
                this.price = item.salePriceRmb;
            }
            
            if(item.isAdmin!=null&&
                item.isAdmin!=undefined&&
                item.isAdmin==1){
                this.isAdmin = item.isAdmin;
            }else{
                this.isAdmin = this.globalIsAdmin;
            }

            this.isNaturalMonth = item.type == 2 || item.type == 10 || item.type == 14 || item.type ==24? true : false; 
            this.showMonthChoose = item.type == 2 || item.type == 10 ||item.type == 14 || item.type ==24? true : false; 
        },

      toRecharge(){
            let self = this;
            var pop = {                
                iccid: this.$store.state.iccid,
                pkgId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                isNextMonth: this.isNextMonth
            }
              //判断是否是月卡
            if(this.isNaturalMonth||this.showMonthChoose==true){
                pop.isNextMonth = this.isNextMonth;
            }else{
                pop.isNextMonth = '0';//万能卡
            }
            if(this.tabbar == 1){
                pop.pkgId=this.itemInfo.id
            }else{
                pop.pkgId=this.itemInfo2.id
            }
              wxRequest("sim/activity/timer",pop, "post").then(res => {
            var result = res.data.data;
            if(res.data.code == 200){
               Dialog.confirm({
                title: "套餐生效提醒",
                message: "生效时间："+res.data.data.start  +"<br/>到期时间："+res.data.data.end+"<br/>"
              })
                .then(() => {
                    
            var data = {                
                iccid: this.$store.state.iccid,
                soldPackageId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                salePriceRmb: this.itemInfo.salePriceRmb,
            }
            
            let data2 = {                
                iccid: this.$store.state.iccid,
                soldPackageId: this.itemInfo2.id,
                isAdmin: this.isAdmin,
                salePriceRmb: this.itemInfo2.salePriceRmb,
            }
            //判断是否是月卡
            if(this.isNaturalMonth||this.showMonthChoose==true){
                data.isNextMonth = this.isNextMonth;
            }else{
                data.isNextMonth = '0';//万能卡
            }

            if(this.$store.state.source != false){
                data.source = this.$store.state.source;
            }else{
                data.source = 'xxgzh';
            }

            this.$store.state.showCheckstand = true;
            this.$store.state.showCheckstandSource = 'flowRecharge';
            if(this.tabbar == 1){
                this.dataToPay = data;
            }else {
                this.dataToPay = data2;
            }
                })
                .catch(() => {});
            }else{
    
            var data = {                
                iccid: this.$store.state.iccid,
                soldPackageId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                salePriceRmb: this.itemInfo.salePriceRmb,
            }

            let data2 = {                
                iccid: this.$store.state.iccid,
                soldPackageId: this.itemInfo2.id,
                isAdmin: this.isAdmin,
                salePriceRmb: this.itemInfo2.salePriceRmb,
            }
            //判断是否是月卡
            if(this.isNaturalMonth){
                data.isNextMonth = this.isNextMonth;
            }else{
                data.isNextMonth = '0';//万能卡
            }

            if(this.$store.state.source != false){
                data.source = this.$store.state.source;
            }else{
                data.source = 'xxgzh';
            }

            this.$store.state.showCheckstand = true;
            this.$store.state.showCheckstandSource = 'flowRecharge';
            if(this.tabbar == 1){
                this.dataToPay = data;
            }else {
                this.dataToPay = data2;
            }
}
        })


 
        },
        //第n天后
        afterManyDays(manyDays){
            let startTime = new Date();
            let startDate = new Date(startTime);
            startDate.setDate(startDate.getDate() + manyDays);
            return this.dateFormat('yyyy-MM-dd', startDate);
        },

        // 本月最后一天
        lastDayOfThisMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 1, 0));
        },

        //下个月第一天
        firstDayOfNextMonth(){
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();

            let date2 = new Date(year, month + 1, 1)
            return this.dateFormat('yyyy-MM-dd', new Date(date2));
        },
        // 下个月最后一天
        lastDayOfNextMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 2, 0));
        },

        changePayType(type){
            this.payType = type;
        },

        //点击tabbar
        tabbarClick(index){
            this.tabbar = index;
            if(this.simData.length != 0 && index == '1'){
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
            }else if(this.simData2.length != 0 && index == '2'){
                this.indexActive2 = this.simData2[0].id;
                this.price = this.simData2[0].salePriceRmb;
                this.itemInfo2 = this.simData2[0];
            }
        }
    },
    created(){
        var data = {
            iccid: this.$store.state.iccid
        }
        wxRequest("sim/user/soldPkg", data, "get").then(res => {
            var result = res.data.data;
            if(res.data.code == 200 && result.list.length > 0){
                this.endTime = result.endTime;
                let resultArray1 = [];
                let resultArray2 = [];
                for(let i=0; i<result.list.length; i++){
                      if(result.list[i].type == 17||result.list[i].type == 14||result.list[i].type == 15||result.list[i].type == 24){
                        this.cuccPkg=true;
                    }
                    // if(result.list[i].type == 11 || result.list[i].type == 13){
                    //     resultArray1.push(result.list[i]);
                    // }else if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                    //     resultArray2.unshift(result.list[i]);
                    // }else {
                    //     resultArray1.unshift(result.list[i]);
                    // }
                    if(result.list[i].type == 11 || result.list[i].type == 13 || result.list[i].type == 4 ||result.list[i].type == 16 || result.list[i].type == 18||result.list[i].type == 20
                     || result.list[i].type == 31||result.list[i].type == 33){
                        this.simData2.push(result.list[i])
                        this.simData2.sort((a,b) => b.flowRate - a.flowRate)
                    }else {
                        if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                            if(!this.endTime){
                                resultArray2.push(result.list[i])
                            }
                        }else {
                            if(result.list[i].packageName.includes('200')){
                                resultArray1.push(result.list[i])
                            }else {
                                resultArray1.unshift(result.list[i])
                            }
                        }
                    }
                }

                this.simData = resultArray1.concat(resultArray2);
                this.isAdmin = result.isAdmin;
                this.globalIsAdmin = result.isAdmin;
                this.isNaturalMonth = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 14 || this.simData[0].type == 24? true : false; 
                
                
                this.simData.sort((a,b) => b.flowRate - a.flowRate)
                this.showMonthChoose = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 14 || this.simData[0].type == 24? true : false; 
                this.itemInfo = this.simData[0];
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                console.log(this.simData[0])
                console.log(this.price)
            }
        })

        /**每月倒数第6天默认选中次月生效**/
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();

        var date2 = new Date(year, month + 1, 0)
        var endDay = date2.getDate();
        day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
    }
}
</script>
<style lang="less">

#rechargeB {
    background: #F5F5F5;
    height: 100%;

    .header {
        padding: 10px 16px;
        background: #fff;
        margin-bottom: 10px;

        div {
            color: #999;
            font-size: 15px;
            line-height: 30px;
        }
        div:nth-child(2){
            color: #333;
            font-size: 18px;
        }
    } 

    
    .packagePanel {
        padding: 5px 16px;
        background: #fff;
        border-bottom: 90px solid #f5f5f5;

        .tabbar {
            display: flex;
            height: 40px;
            margin-bottom: 10px;
            p {
                flex: 1;
                height: inherit;
                text-align: center;
                line-height: 40px;
            }
            .activeTab {
                background: #8fbbe6;
                border-bottom: 2px solid #1989fa;
                color: #1989fa;
            }
        }

        .package-title{
            padding: 10px 0;
            color: #333;
            font-weight:bold;
        }

        .package{
            display: flex;
            position: relative;
            margin-bottom: 20px;

            .label-defined{
                display: block;
                border-width: 14px 18px 14px 18px;
                border-style: solid;
                border-color: transparent;
                position: absolute;  

                label{
                    position: absolute;
                    left: -14px;
                    top: -12px;
                    background: transparent;
                } 
            }

            .label-defined-active{
                border-color: red transparent transparent red;
            }


            .package-name{
                flex-grow: 1;
                padding: 5px 0 5px 20px;
                border: 1px dashed #26a2ff;

                h1{
                    margin: 5px 0;
                    color: #26a2ff;
                    font-size: 18px;
                }

                p{
                    margin: 10px 0;
                    color: #333;
                    font-size: 14px;
                }
            }

            .package-name.overlay-package{
                border-color: #07c160;
            }

            .package-price{
                flex-grow: 0;
                width: 80px;
                border: 1px solid #26a2ff;

                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                p{
                    margin: 5px 0;
                    color: #fff;
                }
                p:last-child{
                    font-size: 18px;
                }

                background: #26a2ff;
            }

            .package-price.overlay-package{
                border-color: #07c160;
                background: #07c160;
            }
            
        }

    }

	


    .toRecharge{
        position: fixed;
        width: 100%;
        bottom: 0;
        font-size: 16px;

        .toRecharge-top{
            background: #F5F5F5;
            display: flex;

            .radio-group-defined{
                display: flex;
                padding-left: 20px;
                justify-content: center;
                align-items: center;
                height: 40px;

                div{
                    height: 20px;
                    margin-right: 15px;
                }
            }

        }

        .detail {
            color: #a0a0a0;
            background: #F5F5F5;
            padding-left: 20px;
            padding-bottom: 5px;
        }

        .toRecharge-bottom{
            display: flex;
            p{
                padding-right: 15px;
                flex-grow: 1;
                color: #333333;
                background:#fff;
                text-align: right;
                line-height: 45px;

                span{
                    color: #26a2ff;
                }
            }

            .toRechargeBtn{
                padding: 0 30px;
                display: inline-block;
                line-height: 45px;
                flex-grow: 0;
                color: #fff;
                background: #26a2ff;
            }
        }

    }
}
</style>
